import { Link } from "@quintype/components";
import get from "lodash/get";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getGlobalPlayerRef } from "../../podcast-player/utils";
import { MobTMRBanner } from "./mob-tmr-banner";

import "./bottom-navbar.m.css";

export const BottomNavbarBase = props => {
  const [active, setActive] = useState();
  const [podcastActive, setPodcastActive] = useState(false);
  const [isHindi, setIsHindi] = useState(false);

  const playerRef = getGlobalPlayerRef();

  const [data] = useState({
    showPlayer: false,
    loadingUserQueue: false,
    playerState: {}
  });

  useEffect(() => {
    setIsHindi(global.location.host.includes("hindi"));
  }, []);

  useEffect(() => {
    switch (props.currentPath) {
      case "/":
        setActive(1);
        break;
      case "/tv":
        setActive(2);
        break;
      case "/saved-stories":
        setActive(4);
        break;
      default:
        setActive(0);
        break;
    }
  }, [props.currentPath, playerRef]);

  const onPodcastClick = () => {
    setActive(3);
    playerRef.setShowMenu(false);
    playerRef.userClickedMicIcon = true;

    if (data.playerState.showPlayerFullScreen) {
      setPodcastActive(true);
      playerRef.state.togglePlayer();
    } else if (data.playerState.showPlayer) {
      setPodcastActive(true);
      playerRef.setShowPlayerFullScreen(true);
    } else {
      setPodcastActive(true);
      playerRef.setCurrentScreen("library");
    }
  };

  const handeleMenuClick = () => {
    playerRef.setShowMenu(!playerRef.state.showMenu);
  };

  const handleTabClick = index => {
    setActive(index);
    setPodcastActive(false);
    playerRef.setShowMenu(false);
    playerRef.setCurrentScreen("");
    playerRef.setShowPlayerFullScreen(false);
  };

  return (
    <React.Fragment>
      <nav styleName="bottom-nav-wrapper">
        <div styleName="tabs">
          <Link styleName={`tab ${active === 1 ? "red" : ""}`} href="/">
            <i
              className="material-icons-outlined "
              onClick={() => handleTabClick(1)}
            >
              home
            </i>
            Home
          </Link>
          <Link styleName={`tab ${active === 2 ? "red" : ""}`} href="/tv">
            <i
              className="material-icons-outlined"
              onClick={() => handleTabClick(2)}
            >
              ondemand_video
            </i>
            Video
          </Link>
          <div
            styleName={`tab ${podcastActive ? "red" : ""}`}
            onClick={onPodcastClick}
          >
            <i className="material-icons">podcasts</i>
            Podcast
          </div>

          <Link
            styleName={`tab ${active === 4 ? "red" : ""}`}
            href={"/saved-stories"}
          >
            <i
              className="material-icons-outlined"
              onClick={() => handleTabClick(4)}
            >
              bookmark_border
            </i>
            Saved
          </Link>

          <div
            styleName={`tab ${data.playerState.showMenu ? "red" : ""}`}
            onClick={handeleMenuClick}
          >
            <i
              className="material-icons-outlined"
              onClick={() => handleTabClick(5)}
            >
              widgets
            </i>
            More
          </div>
        </div>
        {!isHindi ? <MobTMRBanner /> : null}
      </nav>
    </React.Fragment>
  );
};

BottomNavbarBase.propTypes = {
  menu: PropTypes.object,
  currentPath: PropTypes.object
};

function mapStateToProps(state) {
  return {
    menu: get(state, ["qt", "data", "navigationMenu"], []),
    currentPath: get(state, ["qt", "currentPath"], "")
  };
}

export const BottomNavbar = connect(mapStateToProps, {})(BottomNavbarBase);
